import useAxios from "../../../../../hooks/useAxios";
import { useContext, useEffect, useRef, useState } from "react";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import useLoading from "../../../../../shared/components/loading/useLoading";
import { catchFunction } from "../../../../../shared/lib/utils";
import { API_DATASETS_LIBRARY } from "../../../../../shared/lib/apiEndpointsResolver";
import BreadcrumbPanel from "../../../../../shared/components/breadcrumb/BreadcrumbPanel";
import DataLibraryCard from "./DataLibraryCard";
import { DATA_EXPLORERS } from "../../../../../shared/lib/routesResolver";
import DataLibraryContext from "../../../../../contexts/dataLibraryContext";

const DataLibraryOverview = () => {
  const axios = useAxios();
  const { setLoading } = useLoading();
  const context = useContext(DataLibraryContext);
  const [datasets, setDatasets] = useState(context.datasets);
  const datasetsRef = useRef([]);
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const breadcrumbItems = [
    { title: "dataLibrary.overview.breadcrumb.first", link: DATA_EXPLORERS },
    { title: "dataLibrary.overview.breadcrumb.second" },
  ];

  const findDatasetsLibrary = () => {
    if (datasets.length === 0) {
      setLoading(true);
      axios
        .get(API_DATASETS_LIBRARY)
        .then((response) => {
          context.setDatasets(response.data);
          setDatasets(response.data);
          datasetsRef.current = response.data;
        })
        .catch(catchFunction)
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    findDatasetsLibrary();
    trackEvent({
      page: "datasets-library-overview",
      event: "page-load",
    });
  }, []);

  return (
    <>
      <div className="px-4 pb-4 sm:px-6">
        <BreadcrumbPanel items={breadcrumbItems} />
      </div>
      <div className="grid flex-1 items-start gap-4 p-4 sm:px-6 sm:py-0">
        <div className="flex items-center justify-between">
          <h2 className="text-3xl font-bold">Dataset Library</h2>
        </div>

        <p className="text-muted-foreground">
          Browse our collection of marketing and hotel datasets to gain insights
          and improve your business decisions.
        </p>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {datasets.map((dataset) => (
            <DataLibraryCard key={dataset.code} dataLibrary={dataset} />
          ))}
        </div>
      </div>
    </>
  );
};

export default DataLibraryOverview;
